// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".xoJ1o3ITPcrNnLGxSco0Jg\\=\\={display:inline;font-size:1rem;font-weight:400;margin-right:0}", "",{"version":3,"sources":["webpack://./resources/js/components/Price/PriceDescription/styles.module.scss"],"names":[],"mappings":"AAAA,4BACI,cAAA,CAEA,cAAA,CADA,eAAA,CAEA,cACJ","sourcesContent":[".price {\n    display: inline;\n    font-weight: 400;\n    font-size: 1rem;\n    margin-right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"price": "xoJ1o3ITPcrNnLGxSco0Jg=="
};
export default ___CSS_LOADER_EXPORT___;
